import { AssetStatus, Playability, RecordingSegment } from '@ftr/contracts/read'
import { RecordingType } from '@ftr/contracts/type/recording'
import { Timecode, generateUuid } from '@ftr/contracts/type/shared'
import { AbstractBuilder } from '@ftr/foundation'
import { LocalDateTime } from '@js-joda/core'

const FIVE_MINUTES = 300000

export class RecordingSegmentBuilder extends AbstractBuilder<RecordingSegment> {
  constructor() {
    super({
      id: generateUuid(),
      recordingId: generateUuid(),
      recordingType: RecordingType.TRM,
      startDateTime: LocalDateTime.parse('2017-05-30T13:31:00.000'),
      timecode: undefined,
      playability: Playability.NotPlayable,
      assetStatus: AssetStatus.Missing,
      hasMultiChannel: false,
      audioChannelCount: 1,
      videoStreamCount: 0,
    })
  }

  withTimecode(duration = FIVE_MINUTES): this {
    Object.assign(this.result, { timecode: new Timecode(this.result.startDateTime, duration) })
    return this
  }

  asStream(): this {
    Object.assign(this.result, { recordingType: RecordingType.Stream })
    return this
  }

  asLive(startDateTime = LocalDateTime.now(), duration = FIVE_MINUTES): this {
    Object.assign(this.result, {
      recordingType: RecordingType.Stream,
      playability: Playability.Live,
      startDateTime,
      timecode: new Timecode(startDateTime, duration),
    })
    return this
  }
}
